// Global setting page

import React, { useEffect, useState } from "react";
import {
  BookmakerSettings,
  CasinoLiveSettings,
  CasinoSettings,
  CupSettings,
  FancyConfigureSettings,
  FancySettings,
  LineConfigureSettings,
  LineMarketSettings,
  MatchOddsSettings,
  SubHeading,
} from "../../shared/Components";
import { CommonModal } from "../../shared/Components/Modal";
import {
  getAxios,
  patchAxios,
  postAxios,
  putAxios,
} from "../../shared/Services/commonService";
import {
  API_GET_BETTINGTYPE_SETTINGS,
  API_GET_GAME_EVENTTYPE_OPTIONS,
  API_BETTINGTYPE_EVENTTYPE_ID,
  API_BETTINGTYPE_STATUS,
} from "../../utils/api/ApiConstant";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import InputTable from "../../shared/Components/UI/InputTable";
import GlobalInputTable from "../../shared/Components/UI/GlobalInputTable";
import { Tab, Tabs } from "../../shared/Components/UI/CustomTabs";
import { useAccessControl } from "../../shared/Hooks/useAccessControl";
import SvgIcon from "../../shared/Components/UI/Svg";

const GameSettings = () => {
  const queryClient = useQueryClient();
  const { hasPermission, isEditSetting } = useAccessControl();
  const [activeKey, setActiveKey] = useState(1);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownResponse, setDropdownResponse] = useState([]);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    updateAll: false,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
    handleUpdate: null,
  });

  useEffect(() => {
    setShowDropdown(false);
    setDropdownResponse([]);
  }, [activeKey]);

  // Fetch event type options for tabs
  const { data: eventtypeOptions, isLoading: eventtypeOptionsLoading } =
    useQuery({
      queryKey: ["eventtypeOptions"],
      queryFn: () =>
        getAxios(`${API_GET_GAME_EVENTTYPE_OPTIONS}`, { isActive: null }),
    });

  console.log(
    "🚀 ~ GameSettings ~ eventtypeOptions sunil ===:",
    eventtypeOptions,
  );
  console.log("🚀 ~ GameSettings ~ activeKey:", activeKey);

  // Fetch betting type settings based on active event type
  const { data: bettingtypeSettings, isLoading: bettingtypeSettingsLoading } =
    useQuery({
      queryKey: ["bettingtypeSettings", activeKey],
      queryFn: () =>
        getAxios(`${API_GET_BETTINGTYPE_SETTINGS}`, {
          eventTypeId: Number(activeKey),
        }),
      enabled: !!activeKey,
      staleTime: 0, // Always fetch fresh data when activeKey changes
      gcacheTime: 0, // Do not cache data to ensure it is refetched when activeKey changes
      placeholderData: [],
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    });

  console.log(
    "🚀 ~ GameSettings ~ bettingtypeSettings=============>>>:",
    bettingtypeSettings,
  );

  const tableData = Array.isArray(bettingtypeSettings)
    ? bettingtypeSettings
    : [];

  const handleUpdate = async (row) => {
    console.log(" Final Updated Row:", row);
    const payload = {
      ...row,
    };

    const res = await postAxios(API_GET_BETTINGTYPE_SETTINGS, payload);

    if (res) {
      queryClient.invalidateQueries({
        queryKey: ["bettingtypeSettings", activeKey],
      });
    }
  };

  const handleAddGameSetting = async () => {
    if (!activeKey) return;

    // const url = API_BETTINGTYPE_EVENTTYPE_ID.replace(
    //   "{eventTypeId}",
    //   Number(activeKey),
    // );

    const res = await getAxios(API_BETTINGTYPE_EVENTTYPE_ID, {
      eventTypeId: activeKey,
    });

    console.log("🚀 ~ handleAddGameSetting ~ res====:", res);

    if (res) {
      queryClient.invalidateQueries({
        queryKey: ["bettingtypeSettings", activeKey],
      });
    }
    setDropdownResponse(Array.isArray(res) ? res : []);

    setShowDropdown((prev) => !prev);
  };

  return (
    <>
      <SubHeading isAddBtn={true} />
      <div className="card-body">
        <Tabs
          id="controlled-tab-example game-setting-flex"
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k)}
          className="tab_bottle"
        >
          {eventtypeOptions?.map((option) => (
            <Tab key={option.Id} eventKey={option.Id} title={option.Name} />
          ))}

          <div className="position-relative">
            {showDropdown && (
              <div
                className="card shadow-sm mt-2 p-2"
                style={{
                  width: "250px",
                }}
              >
                {dropdownResponse.map((item) => (
                  <div className="dropdown-item cursor-pointer">
                    {item.Name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Tabs>
        {bettingtypeSettingsLoading ? (
          <div>Loading...</div>
        ) : tableData.length > 0 ? (
          <GlobalInputTable
            tableData={tableData}
            activeKey={activeKey}
            onUpdate={handleUpdate}
            canUpdate={isEditSetting}
            handleModal={setIsShow}
          />
        ) : (
          <div className="not_rows">
            <SvgIcon className="not_icon" name="notData" />
            No data available.
          </div>
        )}
      </div>

      {/* <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                updateAll: false,
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
            updateAll: isShow.updateAll,
            handleFn: isShow.handleUpdate,
          })}
      </CommonModal> */}

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          // size={isShow.size}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
          size={isShow.modalSize}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              updateAll: isShow.updateAll,
              isConfirmed: isShow.isConfirmed,
              handleFn: isShow.handleUpdate,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default GameSettings;
